import { combineReducers } from 'redux';

import marketAutocompleteReducer from './autocomplete/marketAutocompleteReducer';
import marketFilterReducer from './filter/marketFilterReducer';
import marketSearchReducer from './search/marketSearchReducer';
import marketSortReducer from './sort/marketSortReducer';

export default combineReducers({
  autocomplete: marketAutocompleteReducer,
  filter: marketFilterReducer,
  search: marketSearchReducer,
  sort: marketSortReducer,
});
